const initializeNewsletterForms = (root = document) => {
  root.querySelectorAll('.rsp-newsletter__form').forEach((form) => {
    if (form.dataset.rspNewsletterReady === 'true') return;

    const button = form.querySelector('[data-rsp-newsletter-submit]');
    const label = button?.querySelector('[data-rsp-newsletter-button-label]');

    if (!button || !label) return;

    form.dataset.rspNewsletterReady = 'true';
    form.addEventListener('submit', () => {
      if (!form.checkValidity() || button.disabled) return;

      button.disabled = true;
      button.classList.add('is-loading');
      button.setAttribute('aria-busy', 'true');
      label.textContent = button.dataset.loadingLabel || 'SUBSCRIBING...';
    });
  });
};

initializeNewsletterForms();

document.addEventListener('shopify:section:load', (event) => {
  initializeNewsletterForms(event.target);
});

